export default {
  payoutSelectionCallbackUrl: import.meta.env.VITE_ROCKER_PAYOUT_SELECTION_CALLBACK_URL,
  authenticationFlow: {
    pollInterval: 1000 * 2,
    callbackUrl: import.meta.env,
  },
};
